import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CashDiscountsDetails from './components/CashDiscountsDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageCashDiscounts',
  components: {
    CashDiscountsDetails
  },
  props: ['isEdit']
})], default_1);
export default default_1;